module.exports = ".form-container {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n    gap: 20px;\n}\n\n.form-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n\n.form-group.full-width {\n    grid-column: span 2;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-transactions/admin-transactions.component.css
// module id = ./src/app/admin-transactions/admin-transactions.component.css
// module chunks = main